import AQToast from "@/components/Generics/AQToast/AQToast.vue";
import { PLATFORM_BASE_PATH } from "@/assets/js/appConfig";
import { $http } from "../../../assets/js/appFunc";

export default {
    components: {
        AQToast
    },
    methods: {
        afterHide() {
            this.$emit("input", false);
        },
        onAction() {
            this.show = false;
        },
        toProfile() {
            this.$store.commit("apps/setCurrentApp", {});
            window.location.href = `/${PLATFORM_BASE_PATH}/userProfile`;
        },
        logout() {
            sessionStorage.clear();
            localStorage.clear();
            $http({ url: "/auth/logout", type: "GET" }, true).then(
                () => {
                    localStorage.setItem("isLogout", true);
                    localStorage.setItem("fromSAML", false);
                    window.location.href = "/";
                }
            )
                .catch(
                    (err) => {
                        const { data } = err.response || {};
                        const { error, path } = data || {};
                        if (!(error === "Forbidden" && path && !path.includes("permissions"))) {
                            this.$toast.showNotify({
                                type: "error",
                                message: this.$t("login.logoutError"),
                                timeout: 10000
                            });
                        }
                    }
                );
        }
    }
};
